import Model from './Model';

export default class FeedConstructorModel extends Model<IProduct> {


}
